import React, { useContext } from "react";
import { Route, Redirect } from "react-router";
import MainLayout from "../layouts/Main.layout";
import { AuthContextDispatchContext } from "../context/auth/AuthContext";

export function PublicRoute({ component: Component, ...rest }) {
  const { isLogged } = useContext(AuthContextDispatchContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLogged === true ? (
          <Redirect
            to={{ pathname: "/app/dashboard", state: { from: props.location } }}
          />
        ) : (
          <MainLayout>
            <Component {...rest} />
          </MainLayout>
        )
      }
    />
  );
}
